import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  CmsNavigationComponent,
  OccEndpointsService
} from "@spartacus/core";
import { CmsComponentData, MediaComponent } from "@spartacus/storefront";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { KNBR_WHATS_NEW } from "src/constants/api.endpoints.constant";

@Component({
    selector: "kn-br-copy-right",
    templateUrl: "./kn-br-copy-right.component.html",
    styleUrls: ["./kn-br-copy-right.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MediaComponent],
})
export class KnBrCopyRightComponent implements OnInit, OnDestroy {
  componentData$: Observable<any> = this.componentData.data$;
  imageData;
  copyRightText: string;
  private destroy$ = new Subject<void>();

  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected httpClient: HttpClient,
    protected endPointService: OccEndpointsService,
    protected cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.componentData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.getCopyRightDataComponent(data.tiles);
      });
  }

  getCopyRightDataComponent(componentName: string): void {
    this.httpClient
      .get(this.endPointService.buildUrl(KNBR_WHATS_NEW(componentName)))
      .pipe(takeUntil(this.destroy$))
      .subscribe((copyRightData: any) => {
        this.imageData = copyRightData.media;
        this.copyRightText = copyRightData.imageMapHTML;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
